import Navbar from "../components/Navbar";
import Universities from "../components/Universities";
import { Footer } from "../components/Footer";

export default function Programs() {
  return (
    <>
      <Navbar />
      <Universities />
      <Footer />
    </>
  );
}